module.exports = "/_next/static/images/AlinPatron-81414872d44e9817e4c3e0b10321532c.webp";